export const DY_DATALAYER_EVENT_NAME = "DY Variation Impression";
